import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initStore } from "./lib/store";
import { installErrorLogger } from "./lib/analytics";
import { initErrorReporter } from "./lib/error-reporter";

initErrorReporter();
installErrorLogger();
initStore();

createRoot(document.getElementById("root")!).render(<App />);
